import { z } from "zod";
import { ChatRequestSchema, ChatResponseSchema, ItineraryDraftSchema, } from "../models/chat-api.schema";
import { processStream } from "../services/sse-stream.service";
import { api } from "@infrastructure/api";
// =============================================================================
// IMPLEMENTATION
// =============================================================================
export const chatRepository = {
    async sendMessage(request) {
        const validated = ChatRequestSchema.parse(request);
        const response = await api.post("/ai/assistant/chat", validated);
        return ChatResponseSchema.parse(response.data);
    },
    async streamMessage(request, callbacks, options = {}) {
        const validated = ChatRequestSchema.parse(request);
        const response = await api.post("/ai/assistant/chat/stream", validated, {
            responseType: "stream",
            adapter: "fetch",
            ...(options.signal ? { signal: options.signal } : {}),
        });
        const headerValue = response.headers["x-conversation-id"];
        const rawConversationId = typeof headerValue === "string" ? headerValue : "";
        const conversationIdResult = z.string().uuid().safeParse(rawConversationId);
        const conversationId = conversationIdResult.success
            ? conversationIdResult.data
            : "";
        const body = response.data;
        if (!body) {
            throw new Error("Response body is null");
        }
        let fullText = "";
        let draft = null;
        const wrappedCallbacks = {
            onTextDelta(text) {
                fullText += text;
                callbacks.onTextDelta?.(text);
            },
            onToolCall(data) {
                callbacks.onToolCall?.(data);
            },
            onToolResult(data) {
                const parsed = ItineraryDraftSchema.safeParse(data.result);
                if (parsed.success) {
                    draft = parsed.data;
                }
                callbacks.onToolResult?.(data);
            },
            onData(data) {
                if (data.type === "data-itinerary-draft") {
                    const parsed = ItineraryDraftSchema.safeParse(data.data);
                    if (parsed.success) {
                        draft = parsed.data;
                    }
                }
            },
            onFinish(data) {
                callbacks.onFinish?.(data);
            },
            onError(error) {
                callbacks.onError?.(error);
            },
        };
        await processStream(body, wrappedCallbacks);
        return { conversationId, fullText, draft };
    },
};
